import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { getCities } from 'models/cities'; // Importing getCities function from models/cities
import { getTags } from 'models/tags'; // Importing getTags function from models/tags
import { getPositions } from 'models/positions'; // Importing getPositions function from models/positions
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from 'config/config'; // Importing devConfig and profile from config

export default class InformationView extends JetView {
    // Defining InformationView class extending JetView
    config() {
        // Method to define the configuration of the view
        const _ = this.app.getService('locale')._; // Getting localization service
        const screen = this.app.config.size; // Getting the screen size configuration
        var image; // Variable to hold image data
        var image2; // Variable to hold second image data
        var image3; // Variable to hold third image data
        var image4; // Variable to hold fourth image data
        var imageFace; // FaceVerification
        var vthis = this; // Preserving the context of 'this'
        const canEditPep = devConfig.getPermAction('customerSecurityUpdatePEPStatus', 'Add');

        const main_info = {
            // Main information layout configuration
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            view: 'template2', // Custom template view
                            data: { DNIP: 'data' }, // Data binding
                            height: 100,
                            name: 'DNIA', // Name of the template
                            template: function (obj) {
                                // Template function to render content
                                image = obj; // Assigning image data
                                if (obj != '')
                                    // Checking if image data exists
                                    return (
                                        '<h6 style=" margin: 0px; ">' +
                                        _('DNI Anterior') + // Localized label
                                        "</h6><img class='dniAnterior' src='" +
                                        obj + // Image source
                                        "' style='cursor:pointer; width:80px; height:80px;'>"
                                    );
                                return '<h6 style=" margin: 0px; ">' + _('No tiene DNI Anterior') + '</h6>'; // Fallback message
                            },
                            onClick: {
                                // Click event handler
                                dniAnterior: function (ev, id) {
                                    // Function to handle click on DNI anterior
                                    webix
                                        .ui({
                                            // Creating a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('DNI Anterior'), // Localized label
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowDNI').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowDNI', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                rows: [
                                                    {
                                                        template: function (obj) {
                                                            // Template for window body
                                                            return (
                                                                "<img src='" +
                                                                image + // Image source
                                                                "' style='cursor:pointer; width:220px; height:180px;'>"
                                                            );
                                                        },
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                        },
                        {
                            rows: [
                                {
                                    view: 'button', // Button to download image
                                    id: 'buttonImage1', // Button ID
                                    value: _('Descargar'), // Localized button label
                                    width: 100,
                                    disabled: true, // Initially disabled
                                    click: function (obj) {
                                        // Click event handler
                                        webix.delay(
                                            // Delay function to allow for UI updates
                                            function () {
                                                var save = document.createElement('a'); // Create anchor element for download
                                                save.setAttribute('href', image); // Set href to image source
                                                save.setAttribute('target', '_blank'); // Open in new tab
                                                save.download = 'imagen.jpg'; // Set download filename
                                                save.click(); // Trigger download
                                            },
                                            '',
                                            '',
                                            200, // Delay time
                                        );
                                    },
                                },
                                {},
                            ],
                        },
                    ],
                },
                {
                    cols: [
                        {
                            view: 'template2', // Another custom template view
                            data: { DNIP: 'data' }, // Data binding
                            height: 100,
                            name: 'DNIP', // Name of the template
                            template: function (obj) {
                                // Template function to render content
                                image2 = obj; // Assigning second image data
                                if (obj != '')
                                    // Checking if image data exists
                                    return (
                                        '<h6 style=" margin: 0px; ">' +
                                        _('DNI Posterior') + // Localized label
                                        "</h6><img class='dniPorterior' src='" +
                                        obj + // Image source
                                        "' style='cursor:pointer; width:80px; height:80px;'>"
                                    );
                                return '<h6 style=" margin: 0px; ">' + _('No tiene DNI Posterior') + '</h6>'; // Fallback message
                            },
                            onClick: {
                                // Click event handler
                                dniPorterior: function (ev, id) {
                                    // Function to handle click on DNI posterior
                                    webix
                                        .ui({
                                            // Creating a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('DNI Posterior'), // Localized label
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowDNIP').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowDNIP', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                rows: [
                                                    {
                                                        template: function (obj) {
                                                            // Template for window body
                                                            return (
                                                                "<img src='" +
                                                                image2 + // Image source
                                                                "' style='cursor:pointer; width:220px; height:180px;'>"
                                                            );
                                                        },
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                        },
                        {
                            rows: [
                                {
                                    view: 'button', // Button to download image
                                    id: 'buttonImage2', // Button ID
                                    value: _('Descargar'), // Localized button label
                                    width: 100,
                                    disabled: true, // Initially disabled
                                    click: function (obj) {
                                        // Click event handler
                                        webix.delay(
                                            // Delay function to allow for UI updates
                                            function () {
                                                var save = document.createElement('a'); // Create anchor element for download
                                                save.setAttribute('href', image2); // Set href to image source
                                                save.setAttribute('target', '_blank'); // Open in new tab
                                                save.download = 'imagen.jpg'; // Set download filename
                                                save.click(); // Trigger download
                                            },
                                            '',
                                            '',
                                            200, // Delay time
                                        );
                                    },
                                },
                                {},
                            ],
                        },
                    ],
                },
                {
                    id: 'TRNA', // ID for TRN anterior section
                    hidden: true, // Initially hidden
                    cols: [
                        {
                            view: 'template2', // Custom template view
                            data: { TRNA: 'data' }, // Data binding
                            height: 100,
                            name: 'TRNA', // Name of the template
                            template: function (obj) {
                                // Template function to render content
                                image3 = obj; // Assigning third image data
                                if (obj != '')
                                    // Checking if image data exists
                                    return (
                                        '<h6 style=" margin: 0px; ">' +
                                        _('TRN Anterior') + // Localized label
                                        "</h6><img class='trnAnterior' src='" +
                                        obj + // Image source
                                        "' style='cursor:pointer; width:80px; height:80px;'>"
                                    );
                                return '<h6 style=" margin: 0px; ">' + _('No tiene TRN Anterior') + '</h6>'; // Fallback message
                            },
                            onClick: {
                                // Click event handler
                                trnAnterior: function (ev, id) {
                                    // Function to handle click on TRN anterior
                                    webix
                                        .ui({
                                            // Creating a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('TRN Anterior'), // Localized label
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowTRN').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowTRN', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                rows: [
                                                    {
                                                        template: function (obj) {
                                                            // Template for window body
                                                            return (
                                                                "<img src='" +
                                                                image3 + // Image source
                                                                "' style='cursor:pointer; width:220px; height:180px;'>"
                                                            );
                                                        },
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                        },
                        {
                            id: 'TRNP', // ID for TRN posterior section
                            rows: [
                                {
                                    view: 'button', // Button to download image
                                    id: 'buttonImage3', // Button ID
                                    value: _('Descargar'), // Localized button label
                                    width: 100,
                                    disabled: true, // Initially disabled
                                    click: function (obj) {
                                        // Click event handler
                                        webix.delay(
                                            // Delay function to allow for UI updates
                                            function () {
                                                var save = document.createElement('a'); // Create anchor element for download
                                                save.setAttribute('href', image3); // Set href to image source
                                                save.setAttribute('target', '_blank'); // Open in new tab
                                                save.download = 'imagen.jpg'; // Set download filename
                                                save.click(); // Trigger download
                                            },
                                            '',
                                            '',
                                            200, // Delay time
                                        );
                                    },
                                },
                                {},
                            ],
                        },
                    ],
                },
                {
                    id: 'TRNP', // ID for TRN posterior section
                    hidden: true, // Initially hidden
                    cols: [
                        {
                            view: 'template2', // Custom template view
                            data: { TRNP: 'data' }, // Data binding
                            height: 100,
                            name: 'TRNP', // Name of the template
                            template: function (obj) {
                                // Template function to render content
                                image4 = obj; // Assigning fourth image data
                                if (obj != '')
                                    // Checking if image data exists
                                    return (
                                        '<h6 style=" margin: 0px; ">' +
                                        _('TRN Posterior') + // Localized label
                                        "</h6><img class='trnPorterior' src='" +
                                        obj + // Image source
                                        "' style='cursor:pointer; width:80px; height:80px;'>"
                                    );
                                return '<h6 style=" margin: 0px; ">' + _('No tiene TRN Posterior') + '</h6>'; // Fallback message
                            },
                            onClick: {
                                // Click event handler
                                trnPorterior: function (ev, id) {
                                    // Function to handle click on TRN posterior
                                    webix
                                        .ui({
                                            // Creating a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('TRN Posterior'), // Localized label
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowTRNP').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowTRNP', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                rows: [
                                                    {
                                                        template: function (obj) {
                                                            // Template for window body
                                                            return (
                                                                "<img src='" +
                                                                image4 + // Image source
                                                                "' style='cursor:pointer; width:220px; height:180px;'>"
                                                            );
                                                        },
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                        },
                        {
                            rows: [
                                {
                                    view: 'button', // Button to download image
                                    id: 'buttonImage4', // Button ID
                                    value: _('Descargar'), // Localized button label
                                    width: 100,
                                    disabled: true, // Initially disabled
                                    click: function (obj) {
                                        // Click event handler
                                        webix.delay(
                                            // Delay function to allow for UI updates
                                            function () {
                                                var save = document.createElement('a'); // Create anchor element for download
                                                save.setAttribute('href', image4); // Set href to image source
                                                save.setAttribute('target', '_blank'); // Open in new tab
                                                save.download = 'imagen.jpg'; // Set download filename
                                                save.click(); // Trigger download
                                            },
                                            '',
                                            '',
                                            200, // Delay time
                                        );
                                    },
                                },
                                {},
                            ],
                        },
                    ],
                },
                {
                    id: 'DNIN', // ID for additional document section
                    hidden: true, // Initially hidden
                    cols: [
                        {
                            view: 'template2', // Custom template view
                            data: { DNIN: 'data' }, // Data binding
                            height: 100,
                            name: 'DNIN', // Name of the template
                            template: function (obj) {
                                // Template function to render content
                                image4 = obj; // Assigning fourth image data
                                if (obj != '')
                                    // Checking if image data exists
                                    return (
                                        '<h6 style=" margin: 0px; ">' +
                                        _('Documento Adicional') + // Localized label
                                        "</h6><img class='trnPorterior' src='" +
                                        obj + // Image source
                                        "' style='cursor:pointer; width:80px; height:80px;'>"
                                    );
                                return '<h6 style=" margin: 0px; ">' + _('No tiene Documento Adicional') + '</h6>'; // Fallback message
                            },
                            onClick: {
                                // Click event handler
                                trnPorterior: function (ev, id) {
                                    // Function to handle click on additional document
                                    webix
                                        .ui({
                                            // Creating a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('Documento Adicional'), // Localized label
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowDNIN').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowDNIN', // Window ID
                                            modal: true, // Modal window
                                            position: 'center', // Center position
                                            body: {
                                                rows: [
                                                    {
                                                        template: function (obj) {
                                                            // Template for window body
                                                            return (
                                                                "<img src='" +
                                                                image4 + // Image source
                                                                "' style='cursor:pointer; width:220px; height:180px;'>"
                                                            );
                                                        },
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                        },
                        {
                            rows: [
                                {
                                    view: 'button', // Button to download image
                                    id: 'buttonImage5', // Button ID
                                    value: _('Descargar'), // Localized button label
                                    width: 100,
                                    disabled: true, // Initially disabled
                                    click: function (obj) {
                                        // Click event handler
                                        webix.delay(
                                            // Delay function to allow for UI updates
                                            function () {
                                                var save = document.createElement('a'); // Create anchor element for download
                                                save.setAttribute('href', image4); // Set href to image source
                                                save.setAttribute('target', '_blank'); // Open in new tab
                                                save.download = 'imagen.jpg'; // Set download filename
                                                save.click(); // Trigger download
                                            },
                                            '',
                                            '',
                                            200, // Delay time
                                        );
                                    },
                                },
                                {},
                            ],
                        },
                    ],
                },
                {
                    view: 'text', // Text input for Partner
                    name: 'Partner',
                    label: _('Partner'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Partner'), // Placeholder text
                    invalidMessage: _(''), // Invalid message
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: _("<span class='icon-id'></span> ID"), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder text
                    invalidMessage: _('A ID is required'), // Invalid message
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for First Name
                    name: 'FirstName',
                    label: _('Primer nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Primer nombre'), // Placeholder text
                    invalidMessage: _('A name is required'), // Invalid message
                },
                {
                    view: 'text', // Text input for Middle Name
                    name: 'MiddleName',
                    label: _('Segundo Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Segundo Nombre'), // Placeholder text
                    invalidMessage: _('A name is required'), // Invalid message
                },
                {
                    view: 'text', // Text input for Last Name
                    name: 'LastName',
                    label: _('Apellido'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Apellido'), // Placeholder text
                },
                {
                    view: 'text', // Text input for Second Last Name
                    name: 'SecondLastName',
                    label: _('Segundo Apellido'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Segundo Apellido'), // Placeholder text
                },
                {
                    view: 'richselect', // Dropdown for Document Type
                    name: 'DocumentType',
                    localId: 'DocumentType:combo', // Local ID for the dropdown
                    label: _('Tipo de Documento'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'C', value: _('DNI') },
                        { id: 'E', value: _('Cedula de Extranjería') },
                        { id: 'P', value: _('Pasaporte') },
                    ],
                    disabled: false, // Enabled input
                },
                {
                    view: 'text', // Text input for Document Number
                    name: 'DocumentNumberJumio',
                    label: _('Número de Documento (Jumio)'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Número de Documento (Jumio)'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for Document Number
                    name: 'DocNumber',
                    label: _('Numero de Documento'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Numero de Documento'), // Placeholder text
                },
                {
                    view: 'datepicker', // Text input for Expiry Date
                    name: 'ExpiryDate',
                    label: _('Fecha de vencimiento del documento'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha de vencimiento del documento'), // Placeholder text
                    format: webix.Date.dateToStr('%Y-%m-%d'), // Date format
                    disabled: !devConfig.getPermAction('PlayerDocumentExpirationDate', 'Add'), // Conditional disabling
                },
                {
                    view: 'richselect', // Dropdown for Gender
                    name: 'Gender',
                    localId: 'Gender:combo', // Local ID for the dropdown
                    label: _('Género'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: ['M', 'F'], // Options for the dropdown
                    disabled: false, // Enabled input
                },
                {
                    view: 'datepicker', // Datepicker for Birth Date
                    name: 'BirthDate',
                    label: _('Cumpleaños'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    format: webix.Date.dateToStr('%d %M %Y'), // Date format
                    disabled: false, // Enabled input
                },
                {
                    view: 'text', // Text input for Currency
                    name: 'Currency',
                    label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Moneda'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for Balance
                    name: 'Balance',
                    label: _('Balance'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Balance'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for Estado
                    name: 'Estado',
                    label: _('Estado'), // Localized label
                    labelPosition: 'top',
                    localId: 'Estado:combo', // Local ID for the dropdown
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for Estado Especial
                    name: 'EstadoEspecial',
                    label: _('Estado Especial'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    disabled: false, // Enabled input
                },
                {
                    view: 'text', // Text input for Is Locked
                    name: 'IsLocked',
                    label: _('Está bloqueado?'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Está bloqueado?'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'textarea', // Textarea for Note
                    name: 'Note',
                    label: _('Observación'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Observación'), // Placeholder text
                    disabled: false, // Enabled input
                    height: 150, // Height of the textarea
                },
                {
                    view: 'text', // Textarea for Note
                    name: 'InactiveAutomaticRule',
                    label: _('Observación por listas automáticas'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Enabled input
                },
                {
                    view: 'text', // Text input for Affiliate
                    name: 'Affiliate',
                    label: _('Afiliador'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Afiliador'), // Placeholder text
                    disabled: !devConfig.getPermAction('assignAffiliateUser', 'Add'), // Conditional disabling
                },
                {
                    view: 'richselect', // Dropdown for Categorization
                    name: 'Categorization',
                    label: _('Categorización'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: ['1', '2', '3', '4', '5'], // Options for the dropdown
                    disabled: false, // Enabled input
                },
                {
                    view: 'text', // Text input for Refers Link
                    name: 'RefersLink',
                    label: _('Link de registro'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Link'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for Is User Test
                    name: 'IsUserTest',
                    id: 'IsUserTest', // ID for the dropdown
                    label: _('Usuario de pruebas'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'S', value: _('Sí') },
                        { id: 'N', value: _('No') },
                    ],
                    disabled: !devConfig.getPermAction('customersInformationIsUserTestSwitch', 'Switch'), // Conditional disabling
                    on: {
                        // Event handler for change event
                        onChange: function (newv, oldv) {
                            // Function to handle change
                            if (newv === 'N') {
                                // If 'No' is selected
                                $$('UserTestProvider').setValue('0'); // Reset UserTestProvider
                                $$('UserTestProvider').disable(); // Disable UserTestProvider
                            } else if (newv === 'S') {
                                // If 'Yes' is selected
                                $$('UserTestProvider').enable(); // Enable UserTestProvider
                                webix.message('Usuario de pruebas activado, escoge un proveedor'); // Show message
                            }
                        },
                    },
                },
            ],
        };
        const notifications = {
            // Notifications section configuration
            view: 'radio', // Radio button view
            name: 'notifications',
            label: _('Notificaciones'), // Localized label
            labelPosition: 'top',
            value: 1, // Default value
            options: [
                // Options for the radio buttons
                { id: 1, value: _('Si') },
                { id: 2, value: _('No') },
            ],
        };
        const left_main = {
            // Left main section configuration
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Including main_info layout
        };
        const more_info = {
            // More information section configuration
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [
                {
                    view: 'richselect', // Dropdown for CountryId
                    name: 'CountryId',
                    id: 'country', // ID for the dropdown
                    localId: 'country:combo', // Local ID for the dropdown
                    label: _('País Residencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for Risk Status
                    name: 'RiskStatus',
                    id: 'RiskStatus', // ID for the dropdown
                    localId: 'RiskStatus:combo', // Local ID for the dropdown
                    label: _('Nivel de Riesgo'), // Localized label
                    labelPosition: 'top',
                    options: [
                        // Options for the dropdown
                        { id: '', value: _('None') },
                        { id: 'A', value: _('Alto') },
                        { id: 'M', value: _('Medio') },
                        { id: 'B', value: _('Bajo') },
                        { id: 'NC', value: _('No Clasificado') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Webix component type: an advanced dropdown (select) input.
                    name: 'LoyaltyLevel', // The name of the field, used when submitting forms or identifying the field logically.
                    id: 'LoyaltyLevel', // A global unique ID for the component, can be used to access it programmatically.
                    localId: 'LoyaltyLevel:combo', // A local ID within the parent layout/component; useful when cloning or reusing views.
                    label: _('Nivel de Lealtad'), // The label displayed to users above the dropdown; translated using the _() function.
                    labelPosition: 'top', // Places the label on top of the dropdown input.
                    options: [ // An array of options available in the dropdown menu.
                        { id: '', value: _('None') }, // Option with an empty value, displayed as "None" (translatable).
                        { id: '1', value: _('1') }, // Option with value "1", displays "1".
                        { id: '2', value: _('2') }, // Option with value "2", displays "2".
                        { id: '3', value: _('3') }, // Option with value "3", displays "3".
                        { id: '4', value: _('4') }, // Option with value "4", displays "4".
                        { id: '5', value: _('5') }, // Option with value "5", displays "5".
                        { id: '6', value: _('6') }, // Option with value "6", displays "6".
                        { id: '7', value: _('7') }, // Option with value "7", displays "7".
                        { id: '8', value: _('8') }, // Option with value "8", displays "8".
                        { id: '9', value: _('9') }, // Option with value "9", displays "9".
                        { id: '10', value: _('10') }, // Option with value "10", displays "10".
                    ],
                    disabled: true, // Disables the dropdown: users cannot interact with it.
                },
                {
                    view: 'richselect', // Dropdown for RegionId
                    name: 'RegionId',
                    id: 'ProvinceRegion', // ID for the dropdown
                    localId: 'ProvinceRegion:combo', // Local ID for the dropdown
                    label: _('Provincia/Región Residencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                    disabled: !devConfig.getPermAction('editRegionUser', 'Add'), // Conditional disabling
                },
                {
                    view: 'richselect', // Dropdown for CityId
                    name: 'CityId',
                    id: 'City', // ID for the dropdown
                    localId: 'cities:combo', // Local ID for the dropdown
                    label: _('Ciudad Residencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                    disabled: !devConfig.getPermAction('editCityUser', 'Add'), // Conditional disabling
                },
                {
                    hidden: !devConfig.getPermAction("viewPlayerAddress", "Add"),
                    view: 'text', // Text input for Address
                    name: 'Address',
                    label: _('Dirección'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Dirección'), // Placeholder text
                    disabled: false, // Enabled input
                },
                {
                    view: 'text', // Text input for Zip Code
                    name: 'ZipCode',
                    label: _('Código Zip'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Código Zip'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    hidden: !devConfig.getPermAction("viewPhonePlayer", "Add"), // Oculta el campo si el usuario no tiene permiso para ver el teléfono del jugador.
                    view: 'text', // Text input for Phone
                    name: 'Phone',
                    label: "<span class='icon-phone1'></span>" + _('Teléfono'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Teléfono'), // Placeholder text
                    type: 'number', // Input type
                    disabled: false, // Enabled input
                },
                {
                    view: 'text', // Text input for Mobile Phone
                    name: 'MobilePhone',
                    label: _('Celular'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Celular'), // Placeholder text
                    type: 'number', // Input type
                    disabled: false, // Enabled input
                    hidden: !devConfig.getPermAction('editPhoneUser', 'Add'), // Conditional hiding
                },
                {
                    view: 'richselect', // Dropdown for Is Activate Phone Verification
                    name: 'IsActivatePhoneVerification',
                    id: 'IsActivatePhoneVerification', // ID for the dropdown
                    label: _('Estado Celular'), // Localized label
                    labelPosition: 'top',
                    localId: 'Estado:combo', // Local ID for the dropdown
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'A', value: _('Verificado') },
                        { id: 'I', value: _('Sin verificar') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for Email
                    name: 'Email',
                    label: _('Email'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Email'), // Placeholder text
                    disabled: false, // Enabled input
                    hidden: !devConfig.getPermAction('editEmailUser', 'Add'), // Conditional hiding
                },
                {
                    view: 'text', // Text input for Created Local Date
                    name: 'CreatedLocalDate',
                    label: _('Fecha de registro'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha de registro'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for Last Login Local Date
                    name: 'LastLoginLocalDate',
                    label: _('Fecha de ultimo login'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha de ultimo login'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: "text", name: "LastIPaddress",
                    label: _("Última dirección IP"), labelPosition: "top",
                    placeholder: _("Última dirección IP"),
                    disabled: true
                },
                {
                    view: 'text', // Text input for Loyalty Points
                    name: 'LoyaltyPoints',
                    label: _('Puntos Lealtad'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Puntos Lealtad'), // Placeholder text
                    type: 'number', // Input type
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for Info2
                    name: 'Info2',
                    label: _('Información Extra') + ' 2', // Localized label
                    labelPosition: 'top',
                    placeholder: _('Información Extra') + ' 2', // Placeholder text
                    disabled: false, // Enabled input
                },
                {
                    view: 'richselect', // Dropdown for State DNI Front
                    name: 'StateDniFront',
                    label: _('Verificó DNI anterior'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'S', value: _('Sí') },
                        { id: 'N', value: _('No') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for State DNI Back
                    name: 'StateDniBack',
                    label: _('Verificó DNI posterior'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'S', value: _('Sí') },
                        { id: 'N', value: _('No') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for State Address
                    name: 'StateAddress',
                    label: _('Verificó domicilio'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'S', value: _('Sí') },
                        { id: 'N', value: _('No') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for Is Activate Advertising
                    name: 'IsActivateAdvertising',
                    label: _('Recibir Publicidad'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'S', value: _('Sí') },
                        { id: 'N', value: _('No') },
                    ],
                    disabled: true, // Disabled input
                },
                {
                    view: 'text', // Text input for Account ID Jumio
                    name: 'AccountIdJumio',
                    label: _('ID de cuenta de jumio'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('ID de cuenta de jumio'), // Placeholder text
                    disabled: false, // Enabled input
                },
                {
                    rows: [
                        // Section for uploading DNI anterior
                        {
                            view: 'template',
                            template: _('Subir DNI Anterior'),
                            type: 'section',
                        }, // Section header
                        {
                            cols: [
                                {
                                    view: 'icon', // Icon for upload
                                    icon: 'icon-drivers-license-o1',
                                    align: 'center',
                                },
                                {
                                    id: 'imageAnt', // ID for uploader
                                    view: 'uploader', // Uploader view
                                    value: _('Subir DNI Anterior'), // Localized label
                                    multiple: false, // Single file upload
                                    autosend: false, // Manual send
                                    name: 'imageAnt', // Name for the uploader
                                    css: 'dni', // CSS class
                                    link: 'mylist2', // Link to list
                                    upload: devConfig.geturlApi() + 'Security/UpdateDNI', // Upload URL
                                    formData: {
                                        // Form data for upload
                                        userid: 123,
                                        document: 'attachment',
                                    },
                                },
                            ],
                        },
                        {
                            view: 'list', // List for uploaded files
                            id: 'mylist2', // ID for the list
                            type: 'uploader', // Uploader type
                            autoheight: true, // Auto height
                            borderless: true, // Borderless style
                        },
                    ],
                },
                {
                    rows: [
                        // Section for uploading DNI posterior
                        {
                            view: 'template',
                            template: _('Subir DNI Posterior'),
                            type: 'section',
                        }, // Section header
                        {
                            cols: [
                                {
                                    view: 'icon', // Icon for upload
                                    icon: 'icon-drivers-license',
                                    align: 'center',
                                },
                                {
                                    id: 'imagePos', // ID for uploader
                                    view: 'uploader', // Uploader view
                                    value: _('Subir DNI Posterior'), // Localized label
                                    multiple: false, // Single file upload
                                    autosend: false, // Manual send
                                    name: 'imagePos', // Name for the uploader
                                    css: 'dni', // CSS class
                                    link: 'mylist', // Link to list
                                    upload: devConfig.geturlApi() + 'Security/UpdateDNI', // Upload URL
                                    formData: {
                                        // Form data for upload
                                        userid: 123,
                                        document: 'attachment',
                                    },
                                },
                            ],
                        },
                        {
                            hidden: !devConfig.getPermAction('viewFaceVerificationJumio', 'Add'), // Conditionally hide the section based on permissions
                            rows: [
                                {
                                    view: 'template', // Section header template
                                    template: _('Imagen Verificación Facial'), // Localized label for the section
                                    type: 'section', // Section type
                                },
                                {
                                    view: 'template2', // Custom template view for displaying the face verification image
                                    name: 'FaceVerification', // Name of the template
                                    height: 100, // Height of the template
                                    borderless: true, // Borderless style
                                    template: function (obj) {
                                        imageFace = obj; // Assign the object to the imageFace variable

                                        if (obj) // Check if the object exists
                                            return (
                                                "<img class='faceVerification' src='" +
                                                obj + // Set the image source
                                                "' style='cursor:pointer;width:80px;height:80px;'>" // Set the image style
                                            );

                                        return (
                                            '<h6 style="margin:0px;">' +
                                            _('Verificación Facial') + // Localized label for face verification
                                            "</h6><div style='width:80px;height:80px;background:#e0e0e0;border-radius:4px;'></div>" // Placeholder for missing image
                                        );
                                    },
                                    onClick: {
                                        faceVerification: function () {
                                            if (!imageFace) return; // Exit if no image is available
                                            webix.ui({
                                                view: 'window', // Create a modal window
                                                modal: true, // Enable modal behavior
                                                position: 'center', // Center the window
                                                head: {
                                                    view: 'toolbar', // Toolbar for the window header
                                                    cols: [
                                                        { view: 'label', label: _('Verificación Facial') }, // Localized label for the window
                                                        {
                                                            view: 'button', // Close button
                                                            label: 'X', // Button label
                                                            width: 30, // Button width
                                                            click: "$$('windowFace').close();", // Close the window on click
                                                        },
                                                    ],
                                                },
                                                id: 'windowFace', // ID for the window
                                                body: {
                                                    template:
                                                        "<div style='display:flex;align-items:center;justify-content:center;height:100%;'>" +
                                                        "<img src='" +
                                                        imageFace + // Set the image source
                                                        "' style='max-width:100%;max-height:100%;'>" + // Set the image style
                                                        '</div>', // Center the image in the window
                                                },
                                            }).show(); // Show the window
                                        },
                                    },
                                },
                                {
                                    rows: [
                                        {
                                            view: 'button', // Button to download the face verification image
                                            id: 'buttonImageFace', // ID for the button
                                            value: _('Descargar'), // Localized label for the button
                                            width: 100, // Button width
                                            disabled: true, // Initially disable the button
                                            click: function () {
                                                var save = document.createElement('a'); // Create an anchor element for downloading
                                                save.setAttribute('href', imageFace); // Set the image source as the href
                                                save.setAttribute('target', '_blank'); // Open the download in a new tab
                                                save.download = 'face_verification.jpg'; // Set the download filename
                                                save.click(); // Trigger the download
                                            },
                                        },
                                        {}, // Empty row for spacing
                                    ],
                                },
                            ],
                        },
                        {
                            view: 'list', // List for uploaded files
                            id: 'mylist', // ID for the list
                            type: 'uploader', // Uploader type
                            autoheight: true, // Auto height
                            borderless: true, // Borderless style
                        },
                    ],
                },
                {
                    view: 'text', // Text input for Usuid Referent
                    name: 'UsuidReferent',
                    label: _('ID Referente'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Referente'), // Placeholder text
                    disabled: true, // Disabled input
                },
                {
                    view: 'richselect', // Dropdown for User Test Provider
                    name: 'UserTestProvider',
                    id: 'UserTestProvider', // ID for the dropdown
                    label: _('Proveedor de pruebas'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: '0', value: _('NINGUNO') },
                        { id: '1', value: _('TECNOLOGIA') },
                        { id: '2', value: _('RIESGO') },
                        { id: '3', value: _('PRODUCTO') },
                        { id: '4', value: _('SAC') },
                        { id: '5', value: _('COMERCIAL') },
                        { id: '6', value: _('PARTNER') },
                        { id: '7', value: _('QUOTA') },
                        { id: '8', value: _('FINANCIERA') },
                        { id: '9', value: _('OPERCOMERCIAL') },
                        { id: '10', value: _('ACCOUNT') },
                    ],
                    disabled: !devConfig.getPermAction('customersInformationIsUserTestSwitch', 'Switch'), // Conditional disabling
                },
                {
                    cols: [
                        {
                            rows: [
                                { view: 'label', label: _('Régimen Reforzado') },
                                {
                                    id: 'IsEnhancedRegimen',
                                    view: 'switch',
                                    labelWidth: 55,
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                    disabled: !canEditPep, // Solo con permiso puede modificar Régimen Reforzado
                                },
                            ],
                        },
                            {
                                rows: [
                                    { view: 'label', label: _('Persona PEP') },
                                    {
                                        id: 'IsPep',
                                        view: 'switch',
                                        labelWidth: 55,
                                        onLabel: _('Si'),
                                        offLabel: _('No'),
                                        disabled: !canEditPep, // Solo con permiso puede modificar PEP
                                    },
                                ],
                            },
                        ],
                },
            ],
        };
        const right_photo = {
            // Right photo section configuration
            gravity: 3,
            margin: 10,
            rows: [
                {
                    view: 'photo', // Photo view
                    name: 'photo',
                    css: 'form_photo', // CSS class
                    width: 260, // Width of the photo
                    height: 260, // Height of the photo
                    borderless: true, // Borderless style
                },
                {
                    view: 'multicombo', // Multi-combo for tags
                    name: 'tags',
                    localId: 'tags:combo', // Local ID for the multi-combo
                    placeholder: _('Click to add tags'), // Placeholder text
                    options: [], // Options for the multi-combo
                },
            ],
        };
        const upper_section = {
            // Upper section layout configuration
            multiview: true, // Multi-view enabled
            padding: 10,
            cols: [left_main, { gravity: 0, minWidth: 20 }, more_info], // Including left_main and more_info
        };
        const upper_section_narrow = {
            // Narrow upper section layout configuration
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info, more_info], // Including main_info and more_info
                },
            ],
        };
        const buttons = {
            // Buttons section configuration
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Save button
                    value: _('Guardar'), // Localized button label
                    type: 'form', // Button type
                    width: 160,
                    click: () => {
                        // Click event handler
                        const newdata = this.getRoot().getValues(); // Get form values
                        var vthis = this; // Preserving the context of 'this'
                        // Mapear switches → API (S/N)
                        newdata.IsPep = $$('IsPep').getValue() == 1 ? 'S' : 'N';
                        newdata.IsEnhancedRegimen = $$('IsEnhancedRegimen').getValue() == 1 ? 'S' : 'N';
                        if (newdata.IsPep === 'S') {
                            newdata.IsEnhancedRegimen = 'S';
                        }
                        if (newdata.IsPep === 'S' && newdata.IsEnhancedRegimen !== 'S') {
                            webix.message({
                                type: 'error',
                                text: _('Si Persona PEP es Si, Régimen Reforzado debe ser Si.'),
                            });
                            return;
                        }
                        if (newdata.ExpiryDate) {
                            newdata.ExpiryDate = webix.Date.dateToStr("%Y-%m-%d")(newdata.ExpiryDate);
                        }
                        if (
                            newdata.IsUserTest === 'S' && // If user test is selected
                            (!newdata.UserTestProvider || newdata.UserTestProvider === 'NINGUNO') // Check if provider is selected
                        ) {
                            webix.message({
                                type: 'error',
                                text: 'Por favor, selecciona un proveedor de pruebas',
                            }); // Show error message
                            return; // Exit function
                        }

                        /**
                         * Encodes the `RefersLink` property of the `newdata` object to Base64 format.
                         * This ensures the link is properly encoded for safe transmission or storage.
                         *
                         * - `unescape` and `encodeURIComponent` are used to handle special characters.
                         * - `btoa` converts the resulting string to Base64.
                         */
                        if (newdata.RefersLink) {
                            newdata.RefersLink = btoa(unescape(encodeURIComponent(newdata.RefersLink)));
                        }

                        if (Object.keys($$('imageAnt').files.data.pull).length > 0) {
                            // If files are uploaded
                            $$('imageAnt').config.formData.Id = newdata.Id; // Set form data ID
                            $$('imageAnt').config.formData.Type = 'A'; // Set type to 'A'
                            $$('imageAnt').send(function (response) {
                                // Send the file
                                webix.message('DNI Enviado'); // Show success message
                            });
                        }
                        if (Object.keys($$('imagePos').files.data.pull).length > 0) {
                            // If files are uploaded
                            $$('imagePos').config.formData.Id = newdata.Id; // Set form data ID
                            $$('imagePos').config.formData.Type = 'P'; // Set type to 'P'
                            $$('imagePos').send(function (response) {
                                // Send the file
                                webix.message('DNI Enviado'); // Show success message
                            });
                        }
                        webix // AJAX request to update client details
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(devConfig.geturlApi() + 'es/Client/UpdateClientDetails', newdata, {
                                // POST request
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    webix.message('Cliente Editado'); // Show success message
                                    vthis.app.callEvent('form:update2', [vthis.getParam('user', true)]); // Call event to update form
                                },
                            });
                    },
                },
            ],
        };
        return {
            // Return the main configuration object
            view: 'form', // Form view
            id: 'formP', // Form ID
            rows: [screen !== 'small' ? upper_section : upper_section_narrow, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for fname
            },
        };
    }

    init(form) {
        // Initialization method
        const _ = this.app.getService('locale')._; // Getting localization service
        webix.ready(function () {
            // Ready event
            webix.attachEvent('onRotate', function (orientation) {
                // Rotate event
                window.location.reload(); // Reload the page on rotation
            });
        });
        var vthis = this; // Preserving the context of 'this'
        const canEditPep = devConfig.getPermAction('customerSecurityUpdatePEPStatus', 'Add'); // Permission to update PEP status

        /**
         * This helper is useful when normalizing values received from
         * different data sources before binding them to a switch control.
         * @param {*} val - Value to normalize.
        */
        function toSwitchValue(val) {
        return val === 'S' || val === true || val === 1 || val === '1' ? 1 : 0;
        }

        /**
         * Synchronizes the state of the PEP and Enhanced Regimen controls.
         */
        function syncPepRegimenState() {
            const pepSwitch = $$('IsPep');
            const regimenSwitch = $$('IsEnhancedRegimen');
            if (!pepSwitch || !regimenSwitch) return;

            if (!canEditPep) {
                pepSwitch.disable();
            } else {
                pepSwitch.enable();
            }
            const isPersonPep = pepSwitch.getValue() == 1;
            if (isPersonPep) {
                regimenSwitch.setValue(1);
                regimenSwitch.disable();
            } else {
                regimenSwitch.enable();
            }
        }
        this.on(this.app, 'form:update2', (id) => {
            // Event handler for form update
            webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientById', 'id=' + id, {
                // AJAX request to get client by ID
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse response text
                    text[0].CreatedLocalDate2 = text[0].CreatedLocalDate; // Set additional date field
                    text[0].RefersLink = Buffer.from(text[0].RefersLink, 'base64').toString('utf-8'); // Set additional date field

                    if (text[0].Partner != undefined && profile.Partners.length > 0) {
                        // Check if partner exists
                        let partnerName = profile.Partners.filter((item) => {
                            // Filter partners
                            return item.id == text[0].Partner; // Match partner ID
                        });
                        if (partnerName.length > 0 && partnerName[0].value != undefined) {
                            text[0].Partner = partnerName[0].value; // Set partner name
                        }
                    }
                    if (text[0].FaceVerification) {
                        $$('buttonImageFace').enable();
                    }
                    if (text[0].IsUSerTest == 'N') {
                        // If user test is 'No'
                        text[0].UserTestProvider = '0'; // Reset user test provider
                    }
                    vthis.app.callEvent('customer:updatedata', [text[0]]); // Call event to update customer data
                    if (text[0].DNIA) {
                        // If DNI anterior exists
                        $$('buttonImage1').enable(); // Enable download button
                    }
                    if (text[0].DNIP) {
                        // If DNI posterior exists
                        $$('buttonImage2').enable(); // Enable download button
                    }
                    if (text[0].TRNA) {
                        // If TRN anterior exists
                        $$('TRNA').show(); // Show TRNA section
                        $$('buttonImage3').enable(); // Enable download button
                    }
                    if (text[0].TRNP) {
                        // If TRN posterior exists
                        $$('TRNP').show(); // Show TRNP section
                        $$('buttonImage4').enable(); // Enable download button
                    }
                    if (text[0].DNIN) {
                        // If additional document exists
                        $$('DNIN').show(); // Show DNIN section
                        $$('buttonImage5').enable(); // Enable download button
                    }
                    $$('country').setValue(text[0].CountryId); // Set country value
                    webix.delay(
                        // Delay for UI updates
                        function () {
                            $$('ProvinceRegion').setValue(text[0].RegionId); // Set region value
                            webix.delay(
                                // Delay for UI updates
                                function () {
                                    $$('City').setValue(text[0].CityId); // Set city value
                                },
                                '',
                                '',
                                1000, // Delay time
                            );
                        },
                        '',
                        '',
                        1000, // Delay time
                    );
                },
            });
        });
        webix // AJAX request to get agent countries
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                // POST request
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse response text
                    var optionsCountries = $$('country').getList(); // Get country options
                    optionsCountries.clearAll(); // Clear existing options
                    optionsCountries.parse(data.Data); // Parse new options
                    vthis.app.callEvent('form:update2', [vthis.getParam('user', true)]); // Call event to update form
                },
            });
        
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event handler for person selection
    
        this.on(this.app, 'customer:updatedata', (person) => {
        const { IsPep, IsEnhancedRegimen, ...rest } = person;
        form.setValues(rest);

        $$('IsEnhancedRegimen').blockEvent();
        $$('IsEnhancedRegimen').setValue(toSwitchValue(IsEnhancedRegimen));
        $$('IsEnhancedRegimen').unblockEvent();

        $$('IsPep').blockEvent();
        $$('IsPep').setValue(toSwitchValue(IsPep));
        $$('IsPep').unblockEvent();

        });
        // function when user is PEP person, immediately disable the “Régimen Reforzado” switch
        if ($$('IsPep')) {
        $$('IsPep').attachEvent('onChange', function () {
            syncPepRegimenState();
        });
        }
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Change event for country dropdown
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province regions
            optionsProvinceRegions.clearAll(); // Clear existing options
            optionsProvinceRegions.parse(optionscountries.departments); // Parse new options
        });
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            // Change event for province region dropdown
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province region
            var optionsCity = $$('City').getList(); // Get city options
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                // Check if province regions exist
                optionsCity.parse(optionsProvinceRegions.cities); // Parse new options
                $$('City').setValue(''); // Reset city value
            }
        });
        var popup = webix.ui({
            // Popup window for editing messages
            view: 'window',
            id: 'editwinMessages',
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Mensaje') }, // Localized label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal window
            body: {}, // Empty body
        });
    }

    getLocalizedComboOptions() {
        // Method to get localized combo options
        const _ = this.app.getService('locale')._; // Getting localization service
        let p_options = webix.copy(getPositions()); // Copying positions options
        p_options.map((x) => (x.value = _(x.value))); // Localizing values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parsing options to dropdown
        let t_options = webix.copy(getTags()); // Copying tags options
        t_options.map((x) => (x.value = _(x.value))); // Localizing values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parsing options to dropdown
        let c_options = webix.copy(getCities()); // Copying cities options
        c_options.map((x) => (x.value = _(x.value))); // Localizing values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parsing options to dropdown
    }
}
webix.protoUI(
    // Defining custom UI component
    {
        name: 'template2', // Name of the component
        getValue: function () {
            // Method to get value
            return this.getValues(); // Return values
        },
        setValue: function (value) {
            // Method to set value
            this.setValues(value); // Set values
        },
    },
    webix.ui.template, // Base template
);

// FILE DOCUMENTED